import {StepConfig, StepperConfig} from '@mydocma/import-export';

export const fileSelectStep1: StepConfig = {
  name: 'selectFile',
  label: 'MM.fault.import.steps.selectFileStep.stepTitle',
  icon: {
    number: 'insert_drive_file',
    edit: 'insert_drive_file',
    done: 'insert_drive_file'
  },
  optional: false,
};

export const validateImportStep2: StepConfig = {
  name: 'validateImport',
  label: 'MM.fault.import.steps.validateImportStep.stepTitle',
  icon: {
    number: 'verified',
    edit: 'verified',
    done: 'verified'
  },
  optional: false
};

export const previewImportStep3: StepConfig = {
  name: 'previewImport',
  label: 'MM.fault.import.steps.previewImportStep.stepTitle',
  icon: {
    number: 'visibility',
    edit: 'visibility',
    done: 'visibility'
  },
  optional: false
};

export const importStepperConfig: StepperConfig = {
  steps: [
    fileSelectStep1,
    validateImportStep2,
    previewImportStep3
  ]
};
